module.exports = __webpack_public_path__ + "static/img/logo-without-slogan.0b4f7b6.png";